export default __webpack_public_path__ + "static/media/nounders_art2.395485ab.png";